import axios from 'axios';
import {authService} from '../../../olsStateManagement/services/auth.service';
import {
    IS_PRODUCTION_ENVIRONMENT,
    LOCALHOST_API_URL,
    DEVELOPMENT_API_URL
    } from '../../../olsStateManagement/helpers/constants';

// API URL
if (IS_PRODUCTION_ENVIRONMENT) {
  axios.defaults.baseURL = LOCALHOST_API_URL
}else {
  axios.defaults.baseURL = DEVELOPMENT_API_URL;
}

// SET DEFAULT LOCALE HEADER TO DETERMINE WEBSITE LANGUAGE
axios.defaults.headers.locale = authService.getLocaleFromUrl();